.list-item {
  list-style-type: none;
  padding: 0;
  margin: 0;
}
